import { Icons } from '@assets/svg'
import { colors } from '@config/theme'
import { AffiliateLinkItem } from '@libs/types/AffiliateLinkItem.ts'
import { Box, Grid, Typography } from '@mui/material'
import { AffiliateGearCard } from '@stories/Components/AffiliateGearCard/AffiliateGearCard.tsx'
import { Text } from '@stories/Typography/Text/Text.tsx'
import styled from 'styled-components'

import favoriteGear from '../../../../favorite_affiliate_gear.json'

const requiredKeys = ['product_title', 'product_descr', 'product_img', 'affiliate_link', 'interest_tags']

const AffiliateGearSection = ({
  renderPage = 'homepage',
  campInterestTags,
}: {
  renderPage?: string
  campInterestTags?: { id: number; name: string }[]
}) => {
  /** Step 1: Remove objects with missing or invalid required fields */
  let validProducts = favoriteGear.filter((product: any) => {
    return requiredKeys.every(
      (key) => Object.prototype.hasOwnProperty.call(product, key) && product[key] !== null && product[key] !== ''
    )
  })
  /** Step 2: For detail Page keep only products with at least one matching badge */
  if (renderPage !== 'homepage' && campInterestTags) {
    validProducts = validProducts.filter((product) =>
      product.interest_tags.some((tag) => campInterestTags.some((badge) => badge.name === tag))
    )
  }

  if (validProducts.length === 0) {
    return null
  }

  const shuffleArray = (array: AffiliateLinkItem[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[array[i], array[j]] = [array[j], array[i]]
    }
    return array
  }
  const shuffled = shuffleArray([...validProducts] as AffiliateLinkItem[])
  const randomGear = shuffled.slice(0, 4)

  return (
    <Box sx={{ flexGrow: 1 }}>
      {renderPage === 'homepage' ? (
        <Text
          variant={'h1'}
          fontSize="36px"
          fontWeight="bold"
          fontFamily={'Ubuntu'}
          letterSpacing={'-1.8px'}
          mb="40px"
          data-testid={`homepage_affiliate_links_heading`}
        >
          Our favorite gear
        </Text>
      ) : (
        <AffiliateGearElementHeader>
          <Icons.FavoriteGearIcon color={colors.brandGray900} />
          <AffiliateGearElementTitle data-testid={`camp_detail_page_affiliate_links_heading`}>
            Favorite Gear
          </AffiliateGearElementTitle>
        </AffiliateGearElementHeader>
      )}

      <Grid
        container
        rowSpacing={2}
        columnSpacing={{ xs: 0, sm: 2, md: 2 }}
        data-testid={`${renderPage}_affiliate_links_content`}
      >
        {randomGear.map((item, index: number) => (
          <AffiliateGearCard data={item} key={index} position={index + 1} renderPage={renderPage} />
        ))}
      </Grid>
      <Text variant={'p'} fontSize="14px" fontWeight="regular" fontFamily={'Inter'} color={colors.brandGray} mt="24px">
        This section contains affiliate links, which means Camperoni may earn a small commission if you purchase through
        them. Camperoni hand picks which products to feature from a large variety of products and retailers, based on
        what we think you and your kiddos may like most.
      </Text>
    </Box>
  )
}

export default AffiliateGearSection

const AffiliateGearElementHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
  margin-bottom: 24px;
`
const AffiliateGearElementTitle = styled(Typography)`
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
  color: ${colors.brandGray900} !important;
`
